import { motion } from "framer-motion";
import { Children, cloneElement } from "react";

export const SidebarActions = ({
    children,
    toolbarProps
}: {
    children?: any;
    toolbarProps?: any;
}) => {
    if (!Array.isArray(children)) {
        children = [children];
    }

    return (
        <motion.div className="sidebarActions" {...toolbarProps}>
            {Children.map(
                children,
                (child, index) =>
                    child && (
                        <div key={child.key || index} className="w-full">
                            {cloneElement(child, { ...child.props, className: "w-full" })}
                        </div>
                    )
            )}
        </motion.div>
    );
};
